exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cell-placeholder[data-v-0b71ecba]{text-align:center;font-size:14px;margin-top:16px;font-weight:400;color:#91969d}.sidebar-helptext[data-v-0b71ecba]{font-size:14px;font-weight:400;color:#c6c6c6;margin:0}.scroll[data-v-0b71ecba]::-webkit-scrollbar{width:4px}.scroll[data-v-0b71ecba]::-webkit-scrollbar-track{background:#c6c6c6}.scroll[data-v-0b71ecba]::-webkit-scrollbar-thumb{background:#91969d;border-radius:4px}.scroll[data-v-0b71ecba]::-webkit-scrollbar-thumb:hover{background:#767c85}.model-status-label[data-v-0b71ecba]{font-size:12px;color:#c6c6c6}.model-status-label.blue[data-v-0b71ecba]{color:#409fec}", ""]);

// exports
